import { cn } from "@/lib/utils";

type Props = {
	answer: string;
	className?: string;
};

/**
 * Renders FAQ answers from the admin textarea.
 * HTML collapses normal whitespace, so newlines must be preserved explicitly.
 */
export default function FaqAnswerText({ answer, className }: Props) {
	const normalized = answer.replace(/\r\n/g, "\n").trim();
	const paragraphs = normalized
		.split(/\n\s*\n/)
		.map((part) => part.trim())
		.filter(Boolean);

	if (paragraphs.length <= 1) {
		return (
			<div className={cn("whitespace-pre-line", className)}>{normalized}</div>
		);
	}

	return (
		<div className={cn("space-y-3", className)}>
			{paragraphs.map((paragraph, index) => (
				<p key={index} className="whitespace-pre-line">
					{paragraph}
				</p>
			))}
		</div>
	);
}
